<div class="padding flex column fix-width">
  <h4 class="bold margin-bottom-small">{{ isEdit ? 'Edit shot type' : 'Create shot type' }}</h4>

  <div class="flex column">
    <div class="flex center">
      <b>Name</b>
      @if (!validation.name) {
        <span class="red margin-left">Required field</span>
      }
    </div>
    <input
      class="margin-top-smallest full-width padding-small border"
      placeholder="e.g. On Model - Flat Lay"
      maxlength="100"
      [(ngModel)]="name"
      [disabled]="loading || nameLocked"
      (ngModelChange)="onNameChange()"
    />
    @if (nameLocked) {
      <span class="grey small margin-top-smallest">The shot type is in use: its name cannot change</span>
    }

    <div class="flex center margin-top">
      <b>Order type</b>
      @if (!validation.orderType) {
        <span class="red margin-left">Required field</span>
      }
    </div>
    <mat-select
      [(value)]="orderTypeId"
      class="margin-top-smallest full-width"
      placeholder="Select an order type"
      [disabled]="loading"
      (selectionChange)="onOrderTypeChange()"
    >
      @for (orderType of orderTypes; track orderType.id) {
        <mat-option [value]="orderType.id">{{ orderType.name }}</mat-option>
      }
    </mat-select>

    @if (!isEdit) {
      <b class="margin-top">Legacy code</b>
      <mat-select
        [(value)]="legacyCode"
        class="margin-top-smallest full-width"
        placeholder="Not exported to Legacy"
        [disabled]="loading"
      >
        <mat-option [value]="null">Not exported to Legacy</mat-option>
        @for (option of legacyCodes; track option.code) {
          <mat-option [value]="option.code">{{ option.code }} - {{ option.description }}</mat-option>
        }
      </mat-select>
    }
  </div>

  <div class="flex column end margin-top">
    <div class="flex center">
      <button class="stroked margin-right-small" (click)="close()">
        <i class="fa-solid fa-undo"></i>
        Discard
      </button>
      <button (click)="apply()" [disabled]="loading">
        <i class="fa-solid fa-check"></i>
        Apply
      </button>
    </div>
  </div>
</div>

@if (loading) {
  <bt-loader></bt-loader>
}
